import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface IArgProps {
  uid: string | null;
  userName: string | null;
  userLocation: string | null;
  phoneNumber: string | null;
}

export const fetchUserProfileApi = createApi({
  reducerPath: "UserProfile",
  baseQuery: fetchBaseQuery({
    baseUrl: `https://firestore.googleapis.com/v1/projects/clone-realtor-557bf/databases/(default)/documents/users`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ["UserProfile"],
  endpoints: (builder) => ({
    getUserProfile: builder.query({
      query: (arg: IArgProps) => ({
        url: `/${arg?.uid}`,
        providesTags: (arg: IArgProps) => [
          {
            type: "UserProfile",
            id: arg.uid,
            userName: arg.userName,
            userLocation: arg.userLocation,
            phoneNumber: arg.phoneNumber
          }
        ]
      })
    })
  })
});

export const { useGetUserProfileQuery } = fetchUserProfileApi;
